<div class="card-body">
    <div class="container">
        <div id="areaPrint">
            <div class="d-flex align-items-center justify-content-center">
                <img src="assets/img/poderjudicial_grey.png" alt="Logo"
                    style="width: 143px; height: 137px; margin-bottom: 14px;">
            </div>

            <div class="table_component" tabindex="0">
                <table>
                    <thead>
                        <tr>
                            <th>{{title}}</th>
                        </tr>
                        <tr>
                            <th>Autoridad que envía: {{OrganoOrigen}}</th>
                        </tr>
                        <tr>
                            <th style="background:var(--primary-blue); padding:8px; font-size:13px">
                                Autoridad que recibe: {{OrganoDestino}}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="tdHeader">
                                Información general
                            </td>
                        </tr>
                   <!--      <tr>
                            <td>
                                Folio de envío: {{acuse.folioEnvio}}
                            </td>
                        </tr> -->
                        <tr>
                            <td>
                                Folio envío: {{acuse.folioRecepcion}}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Fecha de Envío: {{acuse.fechaEnvio}}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Hora de Envío: {{acuse.horaEnvio}}
                            </td>
                        </tr>
                     <!--    <tr>
                            <td>
                                Fecha de Recepción: {{acuse.fechaRecepcion}}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Hora de Recepción: {{acuse.horaRecepcion}}
                            </td>
                        </tr> -->
                        @if(acuse.tipoAcuse===TipoAcuseEnum.Demanda)
                        {
                        <tr>
                            <td>
                                Promovente: {{acuse.promovente}}
                            </td>
                        </tr>
                        }
                        @if(acuse.tipoAcuse===TipoAcuseEnum.Promocion)
                        {
                        <tr>
                            <td>
                                Número de Expediente: {{acuse.numeroExpediente}}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Tipo Asunto: {{acuse.tipoAsunto}}
                            </td>
                        </tr>
                        }

                    </tbody>
                </table>
            </div>

            <div class="table_file mt-3">
                <table>
                    <tbody>
                        <tr>
                            <td colspan="2" class="tdHeader-file">
                                Archivos Enviados
                            </td>
                        </tr>
                        @for(sig of acuse.firmantesDoctos;track $index)
                        {
                        <tr>
                            <td>
                                <div class="row justify-content-center">
                                    <div class="col-sm-auto">
                                        Con evidencia criptográfica de la firma electrónica de: {{sig.signer}}
                                    </div>
                                </div>
                            </td>
                            <td>
                                @for(ar of sig.documentos;track $index)
                                {
                                <div class="row">
                                   <div class="col-sm-auto">
                                        {{ $index + 1 }}
                                    </div>
                                    <div class="col-sm-auto">
                                        Nombre:{{ar.name}},Tamaño:{{ar.size}} bytes
                                    </div>
                                </div>
                                }
                            </td>
                        </tr>
                        }
                    </tbody>
                </table>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-sm-4">
                <button type="button" class="btn-search-promotion" (click)="printAcuse()">
                    <i class="far fa-file-pdf"></i> Imprimir Acuse
                </button>
            </div>
        </div>
    </div>

</div>